const burger = document.querySelector('#burger');
const menu = document.querySelector('#menu');

if (burger && menu) {
  let isOpen = false;

  burger.addEventListener('click', () => {
    isOpen = !isOpen;

    if (!isOpen) {
      burger.classList.remove('burger--open');
      menu.classList.remove('header__menu--open');
      menu.classList.remove('animate--visible');
      document.body.classList.remove('no-scroll');
    } else {
      burger.classList.add('burger--open');
      menu.classList.add('header__menu--open');
      menu.classList.add('animate--visible');
      document.body.classList.add('no-scroll');
    }
  });
}
